import { STCAPIAdatper } from '../../core/configs/stc_integration';
import { MicroRoutes } from './micro_routes';
import { addSubscribers } from './subscribers';

interface IWindowSGDDesktop extends Window {
  hiReady: (callback: () => void) => void;
  $ip: {
    require<M>(s: string): Promise<M>;
    requires<M>(s: string[]): Promise<M[]>;
  };
}

declare var window: IWindowSGDDesktop;

export class HostingService {
  readonly disabledProcesses = [
    'authentication',
    'interaction',
    'navigation',
    'analytics',
    'loading',
    'logging',
    'product',
    'session',
    'sentry',
    'layout',
    'menu',
    'view'
    //'history',
    // 'network',
  ].reduce((_, processName) => ({ ..._, [processName]: { disabled: true } }), {});

  hosting: any;
  hostMicro: any;
  apiHostingIO: any;
  hostListener: Function;

  NetworkUrlConfiguration: any;
  appConfigModel: any;
  accountModel: any;

  async initializeHosting() {
    const Hosting: any = await window.$ip.require('@eab-fip/fi-hosting');
    const hosting = new Hosting();

    // startup the hosting instance
    //
    await hosting.startup({
      ...this.disabledProcesses
    });

    this.hosting = hosting;
    return this;
  }

  async initializeMicro(hostMicroEl: Element, ngMicroRoutes: typeof MicroRoutes) {
    const Micro: any = await window.$ip.require('@eab-fip/fi-micro');
    const hostMicro = new Micro();

    const routes = ngMicroRoutes.createRoutes({
      token: this.accountModel.token,
      server: this.NetworkUrlConfiguration.configure().prependUrl || ''
    });

    addSubscribers(hostMicro);

    await hostMicro.startup(hostMicroEl, {
      id: 'sgd-host-micro',
      micro_interlink: routes.micro_interlink,
      routes,
      view: {
        environment: 'local',
        configuration: {},
        parameters: {},
        constants: {}
      },
      settings: {
        use_life_cycle: true
      }
    });

    const microEventQuery = { site: 'fi-micro', status: ['failure', 'success'] };
    const hostListener = hostMicro.ess.on(microEventQuery, hostMicro.ess.reporters.console);

    // if you think routes are not being converted correctly
    //
    // hostMicro.ess.on(
    //   {
    //     site: 'fi-micro',
    //     source: 'view_model',
    //     action: 'build-routing-table'
    //   },
    //   (e) => console.dir(e)
    // );

    this.hostListener = hostListener;
    this.hostMicro = hostMicro;
    return this;
  }

  async initializeIO(ngSTCAPIAdatper: STCAPIAdatper) {
    // get the api/hosting adapter so we can augment the rules
    //
    const io: any = await window.$ip.require('@eab-pip/pi-io');
    const apiHostingIO = io.adapter('api/hosting');

    // turn on csrf authorization on all pi-io invocations
    //
    apiHostingIO
      .intercept(io.fn.api.request.authorization)
      .intercept(io.fn.api.request.defaults)
      .intercept(io.fn.api.response.noContent)
      .intercept(io.fn.api.response.exposeRedirect)
      .intercept(io.fn.api.response.humanReadableErrors)
      .options({
        defaults: {
          api: {
            headers: {
              'Content-Type': 'application/json;odata=verbose',
              'user-mode': 'student'
            }
          }
        },
        authorization: {
          type: 'csrf',
          overwrite_authorization: false
        }
      });

    // integrate stc api with hi-http
    //
    const $win = window as any;
    $win.hiReady(() => {
      $win.HIP.aop.pointCut('hi-http', 'invoke', (httpInvokeFn: any) => {
        return ngSTCAPIAdatper.createHTTPPointCut(httpInvokeFn);
      });
    });

    // integrate stc api with pi-io
    //
    apiHostingIO.intercept(ngSTCAPIAdatper.createIOInterceptor());

    // for debugging
    //
    this.apiHostingIO = apiHostingIO;
    return this;
  }

  /**
   * called before we startup the micro
   */
  async defineGlobalConstants() {
    const $win = window as any;

    $win.$ip.constants.upgrade({
      '@stc_api_base_uri': this.appConfigModel.getConfigProperty('core-campus_url') || '',
      '@sgd_api_base_uri': this.NetworkUrlConfiguration.configure().prependUrl || '',
      '@sgd_var__student_nk': this.accountModel.student_nk
    });
  }
}

export const initializeHosting = async (
  ngHostingService: HostingService,
  ngSTCAPIAdatper: STCAPIAdatper,
  NetworkUrlConfiguration: any,
  appConfigModel: any,
  accountModel: any
) => {
  try {
    ngHostingService.NetworkUrlConfiguration = NetworkUrlConfiguration;
    ngHostingService.appConfigModel = appConfigModel;
    ngHostingService.accountModel = accountModel;

    await ngHostingService.initializeHosting();
    await ngHostingService.initializeIO(ngSTCAPIAdatper);
  } catch (e) {}
};



// WEBPACK FOOTER //
// ./app/lib/host/services/hosting_service.ts